import LoaderElement from "./LoaderElement";

export default function LoaderElementFull() {
  return (
    <div style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <LoaderElement />
    </div>
  )
}